import React, { useEffect, useState } from "react";
import CloseIcon from "@material-ui/icons/Close";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  makeStyles,
  Paper,
  Chip,
  Dialog,
  Typography,
  CircularProgress,
  Select,
  MenuItem,
  IconButton,
} from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import SaveIcon from "@material-ui/icons/Save";
import CancelIcon from "@material-ui/icons/Cancel";
import ClearIcon from "@material-ui/icons/Clear";
import {
  dateFormated,
  presentFormatedData,
} from "../../functionalComponents/dataFormatFunctions";
import EditSponsorPOColumns from "../POColumns/EditSponsorPOColumns";
import EditCDMOPOColumns from "../POColumns/EditCDMOPOColumns";
import axios from "axios";
import { appUrl } from "../../../../../../utils/config";
// import { useDispatch } from "react-redux";
// import { fetchSLFromPODashboard } from "../../../../containers/actions/common/purchaseOrderAction";

const useStyles = makeStyles(() => ({
  tableContainer: {
    maxHeight: 400, // Scrollable height
    overflowX: "auto",
  },
  headerCell: {
    backgroundColor: "#eee",
    fontWeight: "bold",
    // textAlign: "center",
    whiteSpace: "nowrap",
    height: "28px",
    padding: "10px",
  },
  groupedHeader: {
    backgroundColor: "#eee",
    fontWeight: "bold",
    textAlign: "center",
    whiteSpace: "nowrap",
    height: "28px",
    //   position: "sticky",
    padding: "10px",
    //   top: 0,
    //     zIndex: 3,
    border: "none",
    paddingBottom: "0px",
  },
}));

const PONegotiationTable = ({ data, handleRefresh, featuresAccess,showPencilIcon}) => {
  const classes = useStyles();
  // const dispatch = useDispatch();
  // const [poData, setPoData] = useState({});
  const [tableLoading, setTableLoading] = useState(false);
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);
  
  // Reason code state
  const [isEditingReasonCode, setIsEditingReasonCode] = useState(false);
  const [selectedReasonCode, setSelectedReasonCode] = useState("");
  const [originalReasonCode, setOriginalReasonCode] = useState("");
  const [reasonCodeChanged, setReasonCodeChanged] = useState(false);
  const [reasonCodes, setReasonCodes] = useState([]);
  const [reasonCodesLoading, setReasonCodesLoading] = useState(false);
  const [reasonCodesFetched, setReasonCodesFetched] = useState(false);
  const [reasonCodeSaving, setReasonCodeSaving] = useState(false);
  
  // Initialize reason code from data
  useEffect(() => {
    const rawReasonCode = data?.scheduleLineDetails?.poLevelReasonCode;
    // Convert null, undefined, empty string, or string "null" or "null - " to ""
    const currentReasonCode = (!rawReasonCode || rawReasonCode === "null" || rawReasonCode === "null - " || rawReasonCode.startsWith("null -")) ? "" : rawReasonCode;
    setSelectedReasonCode(currentReasonCode);
    setOriginalReasonCode(currentReasonCode);
    setReasonCodeChanged(false);
    setIsEditingReasonCode(false);
  }, [data]);
  
  //console.log("featuresAccessInTimeAndQty", featuresAccess);
  //console.log("showPencilIcon value in Ponegationtable",showPencilIcon)

  // useEffect(() => {
  //   let requestObj = {
  //     schrockenSAID: data?.scheduleLineDetails?.schrockenSAID,
  //     fgMaterialCode: null,
  //     scheduleLineStatusID: 0,
  //     pageNumber: 1,
  //     pageSize: 5,
  //   };
  //   setTableLoading(true);

  // useEffect(() => {
  //   if (data) {
  //     const Body = {
  //       schrockenSLID: data?.scheduleLineDetails?.schrockenSLID,
  //     };
  //     setLoading(true);

  //     axios
  //       .post(
  //         `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/checkedNewProposal`,
  //         Body // ✅ Comma added here
  //       )
  //       .then((res) => {
  //         if (res.data.status) {
  //           console.log("Proposal checked successfully");
  //         }
  //       })
  //       .catch((err) => {
  //         console.error("API Error:", err);
  //       })
  //       .finally(() => {
  //         setLoading(false);
  //       });
  //   }
  // }, [data]);

  //   axios
  //     .post(
  //       `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchPOLineItems`,
  //       requestObj
  //     )
  //     .then((res) => {
  //       if (res.data.status) {
  //         const fetchedData = res.data.data.SLDetails.map((item) => ({
  //           ...item,
  //         }));
  //         if (Array.isArray(fetchedData) && fetchedData.length > 0) {
  //           setPoData({
  //             ...res.data.data,
  //             SLDetails: fetchedData[0],
  //           });
  //         } else {
  //           setPoData({});
  //           setError(true);
  //         }

  //         setTableLoading(false);
  //       } else {
  //         setError(true); // If API response is not successful
  //       }
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //       setError(true);
  //     })
  //     .finally(() => {
  //       setTableLoading(false);
  //     });
  // }, [data]);

  // Fetch reason codes from API
  const fetchReasonCodes = async () => {
    try {
      const requestObject = {
        searchField: "all",
        searchValue: "",
        reasonCodeGroupType: "all",
        reasonCodeType: "all",
        status: "all",
        collaboratorTypeID: "all",
      };
      const response = await axios.post(
        `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchReasonCodes`,
        requestObject
      );
      if (response.data.status) {
        return response.data?.data?.reasonCodeList || [];
      }
      return [];
    } catch (err) {
      console.error("Error fetching reason codes:", err);
      return [];
    }
  };

  // Save reason code to PO
  const saveReasonCodeToPO = async (schrockenSLID, reasonCode) => {
    try {
      const requestBody = {
        vendorMosymphonyID: data?.scheduleLineDetails?.vendorMosymphonyID,
        poLevelReasonCode: reasonCode || null,
        schrockenSLID:data?.scheduleLineDetails?.schrockenSLID,
      };
      const response = await axios.post(
        `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/updateSLForPOMgmt`,
        requestBody
      );
      if (response.data.status) {
        setOriginalReasonCode(reasonCode);
        return true;
      }
      throw new Error("Failed to save reason code");
    } catch (err) {
      console.error("Error saving reason code:", err);
      throw err;
    }
  };

  // Refresh SL data and trigger purchase orders refresh with page reset but maintain filters
  // const refreshSLData = async () => {
  //   const schrockenSLID = data?.scheduleLineDetails?.schrockenSLID;
    
  //   try {
  //     // Refresh the main purchase orders data and reset to page 1 
  //     // since the updated record will be on page 1 after reason code update
  //     // Using 'reasonCodeUpdated' as a custom type to reset page but maintain filters
  //     if (typeof handleRefresh === "function") {
  //       handleRefresh('reasonCodeUpdated');
  //     }
      
  //     // Then refresh the specific SL data
  //     if (schrockenSLID && dispatch) {
  //       await dispatch(fetchSLFromPODashboard(schrockenSLID));
  //     }
  //   } catch (error) {
  //     console.error("Failed to refresh data:", error);
  //   }
  // };

  // Handle pencil icon click - fetch reason codes and enable editing
  const handleEditReasonCodeClick = async () => {
    setIsEditingReasonCode(true);
    if (!reasonCodesFetched) {
      setReasonCodesLoading(true);
      try {
        const codes = await fetchReasonCodes();
        setReasonCodes(codes);
        setReasonCodesFetched(true);
      } catch (err) {
        console.error("Error fetching reason codes:", err);
        setReasonCodes([]);
      } finally {
        setReasonCodesLoading(false);
      }
    }
  };

  // Handle dropdown open - fetch reason codes if not already fetched
  const handleDropdownOpen = async () => {
    if (!reasonCodesFetched) {
      setReasonCodesLoading(true);
      try {
        const codes = await fetchReasonCodes();
        setReasonCodes(codes);
        setReasonCodesFetched(true);
      } catch (err) {
        console.error("Error fetching reason codes:", err);
        setReasonCodes([]);
      } finally {
        setReasonCodesLoading(false);
      }
    }
  };

  // Handle clear reason code
  const handleClearReasonCode = () => {
    setSelectedReasonCode("");
    setReasonCodeChanged("" !== originalReasonCode);
  };

  // Handle cancel edit
  const handleCancelEdit = () => {
    setSelectedReasonCode(originalReasonCode);
    setReasonCodeChanged(false);
    setIsEditingReasonCode(false);
  };


  // Handle save reason code
  const handleSaveReasonCode = async () => {
    setReasonCodeSaving(true);
    try {
      await saveReasonCodeToPO(
        data?.scheduleLineDetails?.schrockenSLID,
        selectedReasonCode
      );
      setOriginalReasonCode(selectedReasonCode);
      setReasonCodeChanged(false);
      setIsEditingReasonCode(false);
      if (typeof handleRefresh === "function") handleRefresh();
      
      // Refresh only SL data instead of full table refresh
      // await refreshSLData();
    } catch (error) {
      console.error("Error saving reason code:", error);
      // You can add error handling here (snackbar, etc.)
    } finally {
      setReasonCodeSaving(false);
    }
  };

  return (
    <React.Fragment>
      <TableContainer
        style={{
          marginTop: "1rem",
          minHeight: "auto",
          maxHeight: "400px",
          width: "90%",
        }}
        component={Paper}
        className={`${classes.tableContainer} default-table-styles`}
      >
        <Table className="default-table-styles">
          {/* Table Head */}
          <TableHead>
            {/* Main header row */}
            <TableRow>
              <TableCell
                align="left"
                className={classes.headerCell}
                rowSpan={2}
              >
                Date Of Creation
              </TableCell>
              {/* <TableCell className={classes.groupedHeader} colSpan={2}>
                Statistical values
              </TableCell> */}
              <TableCell
                align="right"
                className={classes.headerCell}
                rowSpan={2}
              >
                Original Qty.
              </TableCell>
              {/* <TableCell className={classes.headerCell} rowSpan={2}>
                PO confirmation date
              </TableCell> */}
              <TableCell
                align="right"
                className={classes.groupedHeader}
                colSpan={2}
              >
                {localStorage.getItem("collabType") === "CMO" ? "SAP SO Values" : "SAP PO Values"}
              </TableCell>
              <TableCell className={classes.groupedHeader} colSpan={2}>
                Sponsor Proposed Values
              </TableCell>
              <TableCell className={classes.groupedHeader} colSpan={2}>
                CMO Proposed Values
              </TableCell>
              <TableCell className={classes.headerCell} rowSpan={2}>
                UOM
              </TableCell>
              <TableCell className={classes.headerCell} rowSpan={2}>
                {localStorage.getItem("collabType") === "CMO" ? "SO-level Reason Code / Description" : "PO-level Reason Code / Description"}
              </TableCell>
              {/* <TableCell className={classes.headerCell} rowSpan={2}>Statistical Date</TableCell> */}
            </TableRow>

            {/* Sub headers */}
            <TableRow>
              {/* <TableCell
                align='right'
                style={{ top: 38, paddingTop:'0px' }}
                className={classes.headerCell}
              >
                Qty
              </TableCell>
              <TableCell
                align='left'
                style={{ top: 38, paddingTop:'0px' }}
                className={classes.headerCell}
              >
                Date
              </TableCell> */}

              <TableCell
                align="right"
                style={{ top: 38, paddingTop: "0px",paddingLeft:"2rem" }}
                className={classes.headerCell}
              >
                Qty.
              </TableCell>
              <TableCell
                align="left"
                style={{ top: 38, paddingTop: "0px" }}
                className={classes.headerCell}
              >
                {/* Stat. date */}
                Statistical Date
              </TableCell>

              <TableCell
                align="right"
                style={{ top: 38, paddingTop: "0px",paddingLeft:"2.3rem" }}
                className={classes.headerCell}
              >
                Qty.
              </TableCell>
              <TableCell
                align="left"
                style={{ top: 38, paddingTop: "0px" }}
                className={classes.headerCell}
              >
                Date
              </TableCell>

              <TableCell
                align="right"
                style={{ top: 38, paddingTop: "0px" }}
                className={classes.headerCell}
              >
                Qty.
              </TableCell>
              <TableCell
                align="left"
                style={{ top: 38, paddingTop: "0px" }}
                className={classes.headerCell}
              >
                Date
              </TableCell>
            </TableRow>
          </TableHead>

          {/* Table Body */}
          {tableLoading ? (
            <TableBody>
              <TableRow>
                <TableCell colSpan={11}>
                  <div style={{ textAlign: "center" }}>
                    <CircularProgress color="primary" thickness={7} />
                  </div>
                </TableCell>
              </TableRow>
            </TableBody>
          ) : error ? (
            <TableBody>
              <TableRow
                style={{
                  border: "2px solid rgb(255,0,0)",
                  backgroundColor: "rgb(255,240,240)",
                  Opacity: 1,
                  textAlign: "center",
                  padding: "0.8rem",
                  fontSize: "0.875rem",
                }}
              >
                <TableCell
                  style={{ padding: "10px" }}
                  colSpan={11}
                  align="center"
                >
                  Something went wrong. Please try again later.
                </TableCell>
              </TableRow>
            </TableBody>
          ) : (
            <TableBody>
              {Object.keys(data).length === 0 ? (
                <TableRow>
                  <TableCell colSpan={11} align="center">
                    No data available
                  </TableCell>
                </TableRow>
              ) : (
                <TableRow>
                  <TableCell
                    align="left"
                    style={{ whiteSpace: "nowrap", padding: "10px" }}
                  >
                    {/* <EditPoCreation data={data?.SADetails} /> */}
                    {dateFormated(
                      data?.scheduleLineDetails?.creationDate,
                      "DD-MMM-YYYY",
                      "NA"
                    )}
                  </TableCell>

                  {/* <TableCell
                    align='right'
                    style={{ whiteSpace: "nowrap", padding: "10px" }}
                  >
                    {presentFormatedData(data?.scheduleLineDetails?.requestedQuantity)}
                  </TableCell>

                  <TableCell
                    align='left'
                    style={{ whiteSpace: "nowrap", padding: "10px" }}
                  >
                    {dateFormated(
                      data?.scheduleLineDetails?.statisticalDate,
                      "DD-MMM-YYYY",
                      "NA"
                    )}
                  </TableCell> */}

                  <TableCell
                    align="right"
                    style={{ whiteSpace: "nowrap", padding: "10px" }}
                  >
                    {presentFormatedData(
                      data?.scheduleLineDetails?.requestedQuantity
                    )}
                  </TableCell>

                  {/* <TableCell
                    align='left'
                    style={{ whiteSpace: "nowrap", padding: "10px" }}
                  >
                    {dateFormated(
                      data?.scheduleLineDetails?.deliveryDate,
                      "DD-MMM-YYYY",
                      "NA"
                    )}
                  </TableCell> */}
                  <TableCell
                    align="right"
                    style={{ whiteSpace: "nowrap", padding: "10px" }}
                  >
                    {/* {(localStorage.collabType === "CMO" &&
                            [22, 21, 23].includes(data?.scheduleLineDetails?.scheduleLineStatusID))
                            ? 'NA'
                          : presentFormatedData(data?.scheduleLineDetails?.targetQuantity, 'NA')} */}
                    {presentFormatedData(
                      data?.scheduleLineDetails?.targetQuantity,
                      "NA"
                    )}
                  </TableCell>
                  <TableCell
                    align="left"
                    style={{ whiteSpace: "nowrap", padding: "10px" }}
                  >
                    {dateFormated(
                      data?.scheduleLineDetails?.statisticalDate,
                      "DD-MMM-YYYY",
                      "NA"
                    )}
                    {/* {dateFormated(
                      data?.scheduleLineDetails?.requestedDate,
                      "DD-MMM-YYYY",
                      "NA"
                    )} */}
                  </TableCell>
                  <EditSponsorPOColumns
                    row={data}
                    handleRefresh={handleRefresh}
                    featuresAccess={featuresAccess}
                    showPencilIcon={showPencilIcon}
                  />
                  <EditCDMOPOColumns
                    row={data}
                    handleRefresh={handleRefresh}
                    featuresAccess={featuresAccess}
                    showPencilIcon={showPencilIcon}
                  />

                  <TableCell
                    align="left"
                    style={{ whiteSpace: "nowrap", padding: "10px" }}
                  >
                    {presentFormatedData(
                      data?.scheduleLineDetails?.targetQuantityUOM
                    )}
                  </TableCell>

                  <TableCell
                    align="left"
                    style={{ whiteSpace: "nowrap", padding: "10px" }}
                  >
                  {/* Reason Code Dropdown with Pencil/Save/Cancel Icons */}
                  <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
                    {/* Reason Code Dropdown - Always visible */}
                    <Select
                      value={selectedReasonCode || ""}
                      onChange={(e) => {
                        setSelectedReasonCode(e.target.value);
                        setReasonCodeChanged(e.target.value !== originalReasonCode);
                      }}
                      onOpen={handleDropdownOpen}
                      displayEmpty
                      style={{ minWidth: 400, background: "#fff", flex: 1,border: "1px solid #ccc",
                        borderRadius: "4px",
                        padding: "4px 8px" }}
                      MenuProps={{
                        PaperProps: {
                          style: {
                            maxHeight: 300,
                            zIndex: 2001,
                          },
                        },
                      }}
                      disabled={!isEditingReasonCode || reasonCodesLoading || reasonCodeSaving}
                      renderValue={(value) => {
                        // Check for null/empty/undefined values OR the string "null" or "null - "
                        if (value===null || value===undefined || value==='' || !value || value==="null" || value==="null - " || (typeof value === 'string' && value.startsWith("null -"))) return "NA";
                        const code = reasonCodes.find((c) => c.reasonCode === value);
                        return code 
                          ? `${code.reasonCode} - ${code.description || code.reasonDescription || ""}`
                          : value;
                      }}
                    >
                      <MenuItem value="">
                      <em style={{ 
      color: "#999", 
      fontStyle: "normal",
      fontFamily: "Roboto, Arial, sans-serif",
      fontSize: "14px",
      fontWeight: 400
    }}>
      Select from list
    </em>
                      </MenuItem>
                      {reasonCodesLoading ? (
                        <MenuItem value="loading" disabled>
                          <em>Loading...</em>
                        </MenuItem>
                      ) : (
                        reasonCodes.map((code) => (
                          <MenuItem key={code.reasonCode} value={code.reasonCode}>
                            {code.reasonCode} - {code.description || code.reasonDescription || ""}
                          </MenuItem>
                        ))
                      )}
                    </Select>
                    {/* Icons - Conditional based on editing state */}
                    {!isEditingReasonCode ? (
                      /* Pencil Icon - Show when not editing */
                      // localStorage.collabType !== "CMO" &&
                      // featuresAccess?.editSponsorProposedValues &&
                      // showPencilIcon &&
                      // data?.scheduleLineDetails?.cmoToUsePOInterface === true 
                      localStorage.collabType !== "CMO" && showPencilIcon && featuresAccess?.editPOReasonCode && (
                        <IconButton 
                          aria-label="edit reason code"
                          size="small"
                          onClick={handleEditReasonCodeClick}
                          style={{ padding: 4, color: "#E78A00" }}
                        >
                          <EditIcon fontSize="large" />
                        </IconButton>
                      )
                    ) : (
                     
                     /* Save and Cancel Icons - Show when editing */
                     <div style={{ display: "flex", flexDirection: "column", gap: "1px" }}>
                     <IconButton
                       aria-label="cancel"
                       size="small"
                       onClick={handleCancelEdit}
                       disabled={reasonCodeSaving}
                       style={{ padding: 2, color: "#000000" }}
                     >
                       <ClearIcon fontSize="small" />
                     </IconButton>
                     <IconButton
                       aria-label="save reason code"
                       size="small"
                       onClick={handleSaveReasonCode}
                       disabled={reasonCodeSaving}
                       style={{ padding: 2, color: "#000000" }}
                     >
                       <SaveIcon fontSize="small" />
                     </IconButton>
                   </div>
                    )}
                  </div>

                  </TableCell>

                </TableRow>
              )}
            </TableBody>
          )}
        </Table>
      </TableContainer>
    </React.Fragment>
  );
};

export default PONegotiationTable;
